const ErrorPage = ({ locale }) => {
  return (
    <>
      <div className="error-container">
        {locale === "en" ? (
          <p>The resource cannot be accessed at this time.</p>
        ) : (
          <p>No se puede acceder al recurso en este momento.</p>
        )}
      </div>
    </>
  );
};

export default ErrorPage;
